module.exports = __webpack_public_path__ + "assets/kosher-en-f07d08.svg";